<div class="container-conversation-edit">
	<div class="edit-content">
		<ion-item lines="none" class="title-edit">
			<ion-input [(ngModel)]="title" labelPlacement="stacked" class="message-textarea"
				placeholder="Nommez cette conversation..." type="text"></ion-input>
		</ion-item>

		<div>
			<ion-item lines="none" class="ion-no-padding dis-flex participant-item">
				<ion-label class="participant-label">
					Participant(s)
				</ion-label>
				@if ((isMailConversation$ | async) !== true) {
				<ion-button (click)="openContactSelectorAsync()" size="small" class="marginLeft10" slot="end">
					<ion-icon slot="icon-only" name="add" class="button-small button-solid"></ion-icon>
				</ion-button>
				}
			</ion-item>

			@if(isLoadingSignal()) {
			<div class="spinner-parent">
				<ion-spinner color="primary"></ion-spinner>
			</div>
			}
			@else {
			<div class="dis-flex">
				<!-- Affichage des groupes. -->
				@if(groups.length > 0) {
				<ng-container>
					<ion-label class="subelement-label">
						Groupe(s)
					</ion-label>
					<ion-list class="width100pc">
						<ion-item *ngFor="let group of groups">
							<ion-avatar class="roundavatar marge-right">
								<ion-icon name="group" class="round"></ion-icon>
							</ion-avatar>
							<ion-label class="label-ellipsis">{{ group.name }} </ion-label>
							@if ((isMailConversation$ | async) !== true) {
							<ion-button (click)="removeAsync(group)" color="danger" slot="end">
								<ion-icon slot="icon-only" name="close"></ion-icon>
							</ion-button>
							}
						</ion-item>
					</ion-list>
				</ng-container>
				}

				<!-- Affichage des contacts. -->
				<ion-label class="subelement-label">
					Contact(s)
				</ion-label>
				@if(uiContacts.length > 0) {
				<ion-list class="width100pc">
					<ion-item *ngFor="let contact of uiContacts">
						<ion-avatar class="roundavatar marge-right">
							@if(contact.groups) {
							<ion-icon name="group" class="round"></ion-icon>
							}
							@else {
							<ion-icon name="person" class="round"></ion-icon>
							}
						</ion-avatar>
						<div class="flx-grow1 dis-flex flex-row">
							<div class="flex-col">
								<ion-label class="label-ellipsis">{{ contact.label }}</ion-label>
								@if(contact.groups) {
								<ion-label class="label-ellipsis groups-label">
									{{ contact.groups }}
								</ion-label>
								}
							</div>
						</div>
						@if ((isMailConversation$ | async) !== true) {
						<ion-button [disabled]="contact.groups || contact._id === userContactId" (click)="removeAsync(contact)"
							color="danger" slot="end">
							<ion-icon slot="icon-only" name="close"></ion-icon>
						</ion-button>
						}
					</ion-item>
				</ion-list>
				}
			</div>
			}
		</div>
	</div>
</div>